module.exports = __webpack_public_path__ + "static/img/page1.c698686.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/supplyHome/page1.jpg
// module id = u3Bn
// module chunks = 2